import React from "react"
export default function LoadingFullScreen(){
    return (<div className="loading-screen">
        <div className="loading-div">
                <span className="loader"></span>
        </div>
      
    </div>)
}
